// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeline {
  position: relative;
  padding-left: 40px;
}

.timeline::before {
  content: "";
  position: absolute;
  left: 15px;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #e0e0e0;
  border-radius: 10px;
}

.timeline::after {
  content: "";
  position: absolute;
  left: 15px;
  top: 0;
  width: 4px;
  background: #28a745;
  border-radius: 10px;
  height: 0;
  animation: fillTimeline 2s ease-in-out forwards;
}

@keyframes fillTimeline {
  0% {
    height: 0;
  }
  100% {
    height: 100%;
  }
}

.timeline-item {
  position: relative;
  margin-bottom: 25px;
  display: flex;
  align-items: flex-start;
}

.timeline-icon {
  position: absolute;
  left: -41px;
  top: 0;
  background: #fff;
  border: 4px solid #dee2e6;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  z-index: 1;
  opacity: 0;
  animation: fadeInIcon 0.5s ease-in-out forwards;
}

.timeline-item:nth-child(1) .timeline-icon {
  animation-delay: 0.3s;
}

.timeline-item:nth-child(2) .timeline-icon {
  animation-delay: 0.6s;
}

.timeline-item:nth-child(3) .timeline-icon {
  animation-delay: 0.9s;
}

.timeline-item:nth-child(4) .timeline-icon {
  animation-delay: 1.2s;
}

.timeline-item:nth-child(5) .timeline-icon {
  animation-delay: 1.5s;
}

.timeline-item:nth-child(6) .timeline-icon {
  animation-delay: 1.8s;
}

@keyframes fadeInIcon {
  0% {
    opacity: 0;
    transform: scale(0.5);
    border-color: #dee2e6;
  }
  100% {
    opacity: 1;
    transform: scale(1);
    border-color: #28a745;
  }
}

.timeline-content {
  margin-left: 30px;
  background: #f8f9fa;
  padding: 12px 15px;
  border-radius: 10px;
  width: 100%;
}

.timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.timeline-time {
  font-size: 12px;
  color: #6c757d;
}

.timeline-user {
  margin-bottom: 6px;
}

.timeline-remark {
  margin-top: 6px;
  padding: 8px;
  background: #fff3cd;
  border-radius: 6px;
  font-size: 13px;
}

/* Status badges */
.status-badge {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.badge-created {
  background: #e7f1ff;
  color: #0d6efd;
}

.badge-pending {
  background: #fff3cd;
  color: #856404;
}

.badge-approved {
  background: #d1e7dd;
  color: #0f5132;
}

.badge-submit {
  background: #cff4fc;
  color: #055160;
}

.badge-reject {
  background: #f8d7da;
  color: #842029;
}

.badge-complete {
  background: #90ed61;
  color: #1d281b;
}


/* Completed item special styling */
.timeline-item.completed .timeline-content {
  background: #e8f8ee; /* light green background */
  border: 1px solid #b7e4c7;
}

.timeline-item.completed .status-badge {
  background: #d1f2de;
  color: #1b8f4a;
  font-weight: 600;
}

.timeline-item.completed .timeline-icon {
  background: #28a745;
  border-color: #28a745;
  color: white;
}

.timeline-item.completed .timeline-icon i {
  color: white;
}

/* Make timeline line green for completed */
.timeline-item.completed::before {
  background: #28a745;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Modal/supplier_app/Workflow/ShowStatus.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,+CAA+C;AACjD;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,qBAAqB;EACvB;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;AAGA,mCAAmC;AACnC;EACE,mBAAmB,EAAE,2BAA2B;EAChD,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB;AACrB","sourcesContent":[".timeline {\n  position: relative;\n  padding-left: 40px;\n}\n\n.timeline::before {\n  content: \"\";\n  position: absolute;\n  left: 15px;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n  background: #e0e0e0;\n  border-radius: 10px;\n}\n\n.timeline::after {\n  content: \"\";\n  position: absolute;\n  left: 15px;\n  top: 0;\n  width: 4px;\n  background: #28a745;\n  border-radius: 10px;\n  height: 0;\n  animation: fillTimeline 2s ease-in-out forwards;\n}\n\n@keyframes fillTimeline {\n  0% {\n    height: 0;\n  }\n  100% {\n    height: 100%;\n  }\n}\n\n.timeline-item {\n  position: relative;\n  margin-bottom: 25px;\n  display: flex;\n  align-items: flex-start;\n}\n\n.timeline-icon {\n  position: absolute;\n  left: -41px;\n  top: 0;\n  background: #fff;\n  border: 4px solid #dee2e6;\n  border-radius: 50%;\n  width: 38px;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  z-index: 1;\n  opacity: 0;\n  animation: fadeInIcon 0.5s ease-in-out forwards;\n}\n\n.timeline-item:nth-child(1) .timeline-icon {\n  animation-delay: 0.3s;\n}\n\n.timeline-item:nth-child(2) .timeline-icon {\n  animation-delay: 0.6s;\n}\n\n.timeline-item:nth-child(3) .timeline-icon {\n  animation-delay: 0.9s;\n}\n\n.timeline-item:nth-child(4) .timeline-icon {\n  animation-delay: 1.2s;\n}\n\n.timeline-item:nth-child(5) .timeline-icon {\n  animation-delay: 1.5s;\n}\n\n.timeline-item:nth-child(6) .timeline-icon {\n  animation-delay: 1.8s;\n}\n\n@keyframes fadeInIcon {\n  0% {\n    opacity: 0;\n    transform: scale(0.5);\n    border-color: #dee2e6;\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n    border-color: #28a745;\n  }\n}\n\n.timeline-content {\n  margin-left: 30px;\n  background: #f8f9fa;\n  padding: 12px 15px;\n  border-radius: 10px;\n  width: 100%;\n}\n\n.timeline-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.timeline-time {\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.timeline-user {\n  margin-bottom: 6px;\n}\n\n.timeline-remark {\n  margin-top: 6px;\n  padding: 8px;\n  background: #fff3cd;\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n/* Status badges */\n.status-badge {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.badge-created {\n  background: #e7f1ff;\n  color: #0d6efd;\n}\n\n.badge-pending {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.badge-approved {\n  background: #d1e7dd;\n  color: #0f5132;\n}\n\n.badge-submit {\n  background: #cff4fc;\n  color: #055160;\n}\n\n.badge-reject {\n  background: #f8d7da;\n  color: #842029;\n}\n\n.badge-complete {\n  background: #90ed61;\n  color: #1d281b;\n}\n\n\n/* Completed item special styling */\n.timeline-item.completed .timeline-content {\n  background: #e8f8ee; /* light green background */\n  border: 1px solid #b7e4c7;\n}\n\n.timeline-item.completed .status-badge {\n  background: #d1f2de;\n  color: #1b8f4a;\n  font-weight: 600;\n}\n\n.timeline-item.completed .timeline-icon {\n  background: #28a745;\n  border-color: #28a745;\n  color: white;\n}\n\n.timeline-item.completed .timeline-icon i {\n  color: white;\n}\n\n/* Make timeline line green for completed */\n.timeline-item.completed::before {\n  background: #28a745;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
